import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'

export const ApacContext = createContext({
  site: '',
  basePath: '',
  hideFooter: false,
  setHideFooter: () => {},
  hideHeader: false,
  setHideHeader: () => {},
})

/**
 * Main provider for the APAC app
 * @param {object} props
 * @param {string} props.site The current site
 * @param {string} props.basePath The base path for the current site
 * @param {React.ReactNode} props.children The children to render
 */
export default function ApacProvider({ children, site, basePath }) {
  const [hideFooter, setHideFooter] = useState(false)
  const [hideHeader, setHideHeader] = useState(false)
  const value = useMemo(
    () => ({
      basePath,
      site,
      hideFooter,
      setHideFooter,
      hideHeader,
      setHideHeader,
    }),
    [basePath, site, hideFooter, setHideFooter, hideHeader, setHideHeader]
  )
  return <ApacContext.Provider value={value}>{children}</ApacContext.Provider>
}

/**
 * Hook that hides the footer on a page
 */
export function useHideFooter() {
  const { setHideFooter } = useContext(ApacContext)

  useEffect(() => {
    setHideFooter(true)
    return () => setHideFooter(false)
  }, [setHideFooter])
}

/**
 * Hook that hides the header on a page
 */
export function useHideHeader() {
  const { setHideHeader } = useContext(ApacContext)

  useEffect(() => {
    setHideHeader(true)
    return () => setHideHeader(false)
  }, [setHideHeader])
}
